import styled from '@emotion/styled';

export const getRowId = (row) => `${row.sku}`;

export const dataGridStyles = {
	'& .MuiDataGrid-columnHeaderTitleContainer': {
		height: 'auto',
		paddingTop: '14px',
		paddingBottom: '14px',
		lineHeight: 1.2,
		whiteSpace: 'normal',
		overflow: 'visible',
		fontFamily: 'Roboto',
		fontWeight: '600',
		fontSize: '16px',
	},
	'& .MuiDataGrid-columnHeaderCheckbox': {
		borderTop: '1px solid #E0E0E0',
		borderLeft: '1px solid #E0E0E0',
		borderRight: '1px solid #E0E0E0',
		backgroundColor: '#f3f4f6',
		minHeight: 60,
		maxHeight: 60,
		height: 60,
	},
	'& .MuiDataGrid-cellCheckbox': {
		borderLeft: '1px solid #E0E0E0',
	},
	'& .MuiDataGrid-cell': {
		borderBottom: '1px solid #E0E0E0',
	},

	'& .border-right': {
		borderRight: '1px solid #E0E0E0',
	},
	'& .border-top': {
		borderTop: '1px solid #E0E0E0',
	},
	'& .border-left': {
		borderLeft: '1px solid #E0E0E0',
	},
	'& .border-bottom': {
		borderBottom: '2px solid #E0E0E0 !important',
	},
	'& .MuiDataGrid-columnHeader--emptyGroup': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .header': {
		backgroundColor: '#f3f4f6',
	},
	'& .header-special': {
		backgroundColor: '#e2e8f0',
	},
	'& .cell-special': {
		backgroundColor: '#f1f5f9',
	},

	'& .group': {
		height: '70px !important',
	},
	'& .group-header-special': {
		height: 'fit-content !important',
		padding: '0 !important',
	},

	'& .MuiDataGrid-scrollbar--vertical': {
		display: 'none',
	},
	'& .MuiDataGrid-filler': {
		height: 'fit-content !important',
	},
	'& .MuiDataGrid-main': {
		paddingBottom: '16px !important',
	},
	'& .no-padding': {
		padding: '0 !important',
	},
	'& .custom-header': {
		minHeight: 60,
		maxHeight: 60,
		height: 60,
	},
	'& .Mui-checked': {
		color: '#354887 !important',
	},
	'& .MuiDataGrid-row.Mui-selected': {
		backgroundColor: '#EDEDFC !important',
	},
};

export const StyledBox = styled('div')(({ theme }) => ({
	width: '100%',
	'& .MuiDataGrid-cell--editing': {
		backgroundColor: 'rgb(255,215,115, 0.19)',
		color: '#1a3e72',
		'& .MuiInputBase-root': {
			height: '100%',
		},
	},
	'& .Mui-error': {
		backgroundColor: `rgb(126,10,15, ${
			theme.palette.mode === 'dark' ? 0 : 0.1
		})`,
		color: theme.palette.error.main,
	},
}));
